export default function PasswordIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      version="1.1"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      width={16}
      height={16}
      x={0}
      y={0}
      viewBox="0 0 32 32"
      // style={{ enableBackground: 'new 0 0 16 16' }}
      xmlSpace="preserve"
      className=""
    >
      <g>
        <g data-name="12-Lock">
          <path
            d="M23 12V8.71A6.72 6.72 0 0 0 16.29 2h-.58A6.72 6.72 0 0 0 9 8.71V12a3 3 0 0 0-3 3v9.3a5.71 5.71 0 0 0 5.7 5.7h8.6a5.71 5.71 0 0 0 5.7-5.7V15a3 3 0 0 0-3-3ZM11 8.71A4.71 4.71 0 0 1 15.71 4h.58A4.71 4.71 0 0 1 21 8.71V12H11ZM24 24.3a3.7 3.7 0 0 1-3.7 3.7h-8.6A3.7 3.7 0 0 1 8 24.3V15a1 1 0 0 1 1-1h14a1 1 0 0 1 1 1Z"
            fill="#0047ab"
            opacity={1}
            data-original="#000000"
            className=""
          />
          <path
            d="M17 20.72V24a1 1 0 0 1-2 0v-3.28a2 2 0 1 1 2 0Z"
            fill="#0047ab"
            opacity={1}
            data-original="#000000"
            className=""
          />
        </g>
      </g>
    </svg>
  );
}
